import $ from 'jquery';
import { MQ } from '../tools/MQ';

export const init = ($slider) => {

	$(document)
		.on('click', '.js-link-slide', function(e) {
			e.preventDefault();

			if ( MQ('mdUp') ) {
				$('body, html').animate({
					/* scrollTop: $( $(this).attr('href') ).offset().top  - $('.b-fixed').outerHeight() - 16, */
					scrollTop: $(this.hash).offset().top  - $('.b-fixed').outerHeight() - 16,
				}, 500, 'linear');
			} else {
				$('body, html').animate({
					/* scrollTop: $( $(this).attr('href') ).offset().top - 16, */
					scrollTop: $( $(this.hash) ).offset().top - 16,
				}, 500, 'linear');

			}
		});

};
